import { render, staticRenderFns } from "./FavoritesIndex.vue?vue&type=template&id=7ed516e2"
import script from "./FavoritesIndex.vue?vue&type=script&lang=js"
export * from "./FavoritesIndex.vue?vue&type=script&lang=js"
import style0 from "./FavoritesIndex.vue?vue&type=style&index=0&id=7ed516e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports